import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Root from '../src/root';

function App({ userGeolocationGuessedCountry }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return <Root userGeolocationGuessedCountry={userGeolocationGuessedCountry} />;
}

App.propTypes = {
  userGeolocationGuessedCountry: PropTypes.string.isRequired,
};

export default App;
